import { render, staticRenderFns } from "./CardCreateDialog.vue?vue&type=template&id=67b66a96"
import script from "./CardCreateDialog.vue?vue&type=script&lang=js"
export * from "./CardCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports